import { combineReducers } from 'redux';

import { State } from '../models/state.model';
import { paymentReducer } from './actions/payment/payment.action';

export const rootReducer = combineReducers<State>({
  payment: paymentReducer,
});
